import React, { Children } from 'react';
import { Star, Quote } from 'lucide-react';
import { motion } from 'framer-motion';
const REVIEWS = [{
  text: "After years of wear, they're still beautiful. The quality is superb. One of the things I was very impressed about was that you didn't feel you had to use the unnecessary screws in the plates — they don't mess with the continuity of the design. AND your customer service is g-r-e-a-t!",
  author: 'Tani C.',
  location: 'Clovis, CA',
  highlight: 'Customer since day one'
}, {
  text: "I received my switchplates and can only say that the photos online do not do these switchplates justice. I've had them up on my light switches a few days and already guests visiting my home have commented on how nice they look.",
  author: 'Maria-E.',
  location: 'Verified Customer',
  highlight: 'Even better in person'
}, {
  text: 'We did an entire wine theme in our kitchen with your wine switchplates. It looks fabulous. It makes the entire kitchen so unique.',
  author: 'Janet',
  location: 'Rhode Island',
  highlight: 'Complete room transformation'
}, {
  text: "I have probably more than 15 of your switchplates all around my house, and I will not stop until every plate is redone! So many great comments on my switchplates — people are just amazed, it's so fun!",
  author: 'Paula',
  location: 'Verified Customer',
  highlight: 'Repeat customer'
}, {
  text: 'You have a really great product, and the way the screws disappear is fantastic!',
  author: 'Anne T.',
  location: 'Verified Customer',
  highlight: 'Invisible screws'
}, {
  text: "I received my order and I couldn't be happier. You guys have a great product and great customer service. This is one of those good customer experiences that the recipient tends to blab to all his friends about!",
  author: 'Jason W.',
  location: 'Verified Customer',
  highlight: 'Spreading the word'
}, {
  text: 'We received the wine theme switch plate covers and they are fabulous! They look very professional and are a lovely added touch to our newly remodeled family room and wine tasting area.',
  author: 'Jennie',
  location: 'Verified Customer',
  highlight: 'Professional finish'
}, {
  text: 'I received my new switchplates and receptacle covers yesterday and I certainly do like them! You do a beautiful job! What a terrific selection your company offers!',
  author: 'Jeanette L.',
  location: 'Verified Customer',
  highlight: 'Beautiful craftsmanship'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 16
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function Testimonials() {
  const leftColumn = REVIEWS.filter((_, i) => i % 2 === 0);
  const rightColumn = REVIEWS.filter((_, i) => i % 2 === 1);
  return <section className="py-24 bg-white" data-id="element-1354">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1355">
        <div className="text-center mb-16" data-id="element-1356">
          <span className="inline-block text-xs font-bold tracking-[0.2em] uppercase text-gold mb-4" data-id="element-1357">
            Real Customer Stories
          </span>
          <h2 className="text-4xl md:text-5xl font-serif text-charcoal mb-6" data-id="element-1358">
            Loved by Homeowners Across the Country
          </h2>
          <div className="flex justify-center items-center gap-1.5 mb-6" data-id="element-1359">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-gold text-gold" data-id="element-1360" />)}
          </div>
          <p className="text-warmGray text-lg max-w-2xl mx-auto leading-relaxed" data-id="element-1361">
            Don't just take our word for it — hear from the customers who've
            transformed their homes with our handcrafted switch plates.
          </p>
        </div>

        {/* Desktop Masonry */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-80px'
      }} className="hidden md:grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-1362">
          <div className="flex flex-col gap-8" data-id="element-1363">
            {leftColumn.map((review, idx) => <TestimonialCard key={idx} review={review} data-id="element-1364" />)}
          </div>
          <div className="flex flex-col gap-8 pt-12" data-id="element-1365">
            {rightColumn.map((review, idx) => <TestimonialCard key={idx} review={review} data-id="element-1366" />)}
          </div>
        </motion.div>

        {/* Mobile List */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true,
        margin: '-40px'
      }} className="md:hidden flex flex-col gap-6" data-id="element-1367">
          {REVIEWS.slice(0, 5).map((review, idx) => <TestimonialCard key={idx} review={review} data-id="element-1368" />)}
        </motion.div>

        <div className="text-center mt-16" data-id="element-1369">
          <a href="/testimonials.html" className="inline-flex items-center text-gold font-bold hover:text-gold-dark transition-colors group text-lg" data-id="element-1370">
            Read More Customer Stories
            <span className="ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-1371">
              →
            </span>
          </a>
        </div>
      </div>
    </section>;
}
function TestimonialCard({
  review
}: {
  review: (typeof REVIEWS)[number];
}) {
  return <motion.div variants={cardVariants} className="bg-cream p-8 rounded-sm shadow-sm border border-warmBorder relative group hover:shadow-warm transition-shadow" data-id="element-1372">
      <Quote className="w-10 h-10 text-gold/20 absolute top-6 right-8" strokeWidth={1} data-id="element-1373" />
      {review.highlight && <span className="inline-block text-[10px] font-bold tracking-[0.15em] uppercase text-gold bg-gold/10 px-3 py-1.5 rounded-sm mb-5" data-id="element-1374">
          {review.highlight}
        </span>}
      <p className="text-charcoal relative z-10 mb-6 leading-relaxed text-lg font-serif italic" data-id="element-1375">
        "{review.text}"
      </p>
      <div className="flex items-center gap-4 border-t border-warmBorder pt-5" data-id="element-1376">
        <div className="w-10 h-10 rounded-full bg-gold/15 flex items-center justify-center flex-shrink-0" data-id="element-1377">
          <span className="text-gold font-serif text-base font-bold" data-id="element-1378">
            {review.author.charAt(0)}
          </span>
        </div>
        <div data-id="element-1379">
          <p className="font-bold text-charcoal text-base" data-id="element-1380">{review.author}</p>
          <p className="text-sm text-warmGray" data-id="element-1381">{review.location}</p>
        </div>
        <div className="ml-auto flex gap-0.5" data-id="element-1382">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-gold/80 text-gold/80" data-id="element-1383" />)}
        </div>
      </div>
    </motion.div>;
}